export enum LocalStorageKeys {
  DrunkStartupsUserIdea = "DrunkStartupsUserIdea",
  GuestParticipantId = "guestParticipantId",
  MySocialView = "mySocialView",
  ActiveOrganizationId = "activeOrganizationId",
  LazyImportRefresh = "lazyImportRefresh",
  ShowVideoStartedToasts = "showVideoStartedToasts",
}
